import React from 'react';

import { useTranslation } from '@wix/yoshi-flow-editor';

import {
  NotificationChannel,
  NotificationSettings,
} from '@wix/ambassador-social-groups-v1-notification-settings/types';

import { useController } from 'common/context/controller';

import { Typography } from 'wui/Typography';
import { Box } from 'wui/Box';
import { TextButton } from 'wui/TextButton';

import { ChannelSettings } from './ChannelSettings';

interface EmailSettingsProps {
  settings: NotificationSettings[];
  onChange(updatedSettings: NotificationSettings[]): void;
  isAutomatedEmailNotificationsEnabled: boolean;
}

export const EmailSettings: React.FC<EmailSettingsProps> = ({
  isAutomatedEmailNotificationsEnabled,
  settings,
  onChange,
}) => {
  const { t } = useTranslation();
  const { members$, verticals$ } = useController();

  if (!isAutomatedEmailNotificationsEnabled) {
    return (
      <ChannelSettings
        channel={NotificationChannel.EMAIL}
        settings={settings}
        onChange={onChange}
      />
    );
  }

  if (!verticals$.hasMembersInstalled) {
    return (
      <Box direction="vertical" gap="SP4">
        <Box direction="vertical" gap="SP1">
          <Typography as="h3" variant="h2-20">
            {t('groups-web.notifications.email.title')}
          </Typography>
          <Typography secondary variant="p2-14">
            {t(
              'groups-web.automated-notifications.email.caption.no-members-area',
            )}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box direction="vertical" gap="SP4">
      <Box direction="vertical" gap="SP1">
        <Typography as="h3" variant="h2-20">
          {t('groups-web.notifications.email.title')}
        </Typography>
        <Typography secondary variant="p2-14">
          {t('groups-web.automated-notifications.email.caption')}
        </Typography>
      </Box>
      <TextButton variant="link" onClick={navigateToAccountSettings}>
        {t('groups-web.automated-notifications.email.button')}
      </TextButton>
    </Box>
  );

  function navigateToAccountSettings() {
    members$.navigateToAccountSettings();
  }
};

EmailSettings.displayName = 'EmailSettings';
